import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../styles/colors';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const MediaSection = styled.section`
  padding: 100px 0;
  background: linear-gradient(135deg, #fff 0%, #f9f9f9 100%);
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: ${colors.primary};
  text-align: center;
  margin-bottom: 3rem;
  position: relative;

  &:after {
    content: '';
    display: block;
    width: 80px;
    height: 3px;
    background: ${colors.accent};
    margin: 20px auto 0;
  }
`;

const MediaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const MediaCard = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 1s ease-out ${props => props.delay}s;
  opacity: 0;
  animation-fill-mode: forwards;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const MediaEmbed = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

const MediaInfo = styled.div`
  padding: 20px;
`;

const MediaTitle = styled.h3`
  color: ${colors.primary};
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

const MediaDescription = styled.p`
  color: ${colors.text};
  font-size: 0.9rem;
  line-height: 1.6;
`;

const Media = () => {
  const mediaContent = [
    {
      type: 'instagram',
      url: 'https://www.instagram.com/reel/DGx5JBMMR7L/',
      title: 'Codename Forresta Showcase',
      description: 'Experience the luxury and elegance of Codename Forresta'
    },
    {
      type: 'instagram',
      url: 'https://www.instagram.com/reel/DHD5WqEJX0J/',
      title: 'Project Highlights',
      description: 'Discover the unique features of our premium residences'
    },
    {
      type: 'youtube',
      url: 'https://www.youtube.com/embed/8jRRGGwgRYI',
      title: 'Project Overview',
      description: 'A comprehensive look at Codename Forresta'
    },
    {
      type: 'youtube',
      url: 'https://www.youtube.com/embed/K7CUFt3d9bg',
      title: 'Virtual Tour',
      description: 'Take a virtual tour of our luxurious apartments'
    },
    {
      type: 'youtube',
      url: 'https://www.youtube.com/embed/6cKTIP0LAog',
      title: 'Project Highlights',
      description: 'Quick highlights of Codename Forresta'
    }
  ];

  return (
    <MediaSection id="media">
      <Container>
        <Title>Media Gallery</Title>
        <MediaGrid>
          {mediaContent.map((item, index) => (
            <MediaCard key={index} delay={0.2 * (index + 1)}>
              <MediaEmbed>
                {item.type === 'youtube' ? (
                  <iframe
                    src={item.url}
                    title={item.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <iframe
                    src={`${item.url}embed`}
                    title={item.title}
                    allowtransparency="true"
                    frameBorder="0"
                    allowFullScreen
                  />
                )}
              </MediaEmbed>
              <MediaInfo>
                <MediaTitle>{item.title}</MediaTitle>
                <MediaDescription>{item.description}</MediaDescription>
              </MediaInfo>
            </MediaCard>
          ))}
        </MediaGrid>
      </Container>
    </MediaSection>
  );
};

export default Media; 